<template>
  <div id="page-templates">
    <h5 class="m-4 page-header"> >> {{ $t('TEMPLATE.TEMPLATES') }}</h5>

    <ErrorPopup
      :error="error_popup_message"
    />
    
    <Confirm
      :title="$t('COMMON.CONFIRM')"
      :message="$t('TEMPLATE.CONFIRM_DELETE')"
      ref="deleteTemplateConfirm"
      type="success"
      @confirm="onDeleteTemplateConfirm"
    />
    
    <memlist-card>
      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">

            <TemplatesTable
              :type="'EMAIL'"
              :items="templates"
              :currentCompanyId="currentCompanyId"
              @refresh="refresh_templates"
              @createTemplateClicked="create_template_clicked"
              @copyTemplateClicked="copy_template"
              @selectTemplateClicked="selectTemplate"
              @deleteTemplateClicked="deleteTemplateClicked"
              @changeSystem="changeSystem"
              
            />

            <TemplateEditorModal
              :type="'EMAIL'"
              ref="template-editor-modal"
              :template_id="selected_template_id"
              @updated="updateTemplate"
              @created="createdTemplate"

            />
          </div>
          <div v-show="active_tab === 1">

            <PDFTemplateTable
              @on_select_item="pdf_template_selected"
              @on_delete_item="pdf_template_deleted"
              @create_clicked="pdf_template_create"

              ref="pdf-template-table"
            />


            <PDFTemplateEditorModal 
              ref="pdf-template-editor-modal"
              :item="selected_pdf_template"
              @updated="pdf_template_updated"
              @created="pdf_template_created"
            />
          </div>
          <div v-show="active_tab === 2">
            <SendoutTemplateComponent />
          </div>
        </div>
      </div>
    </memlist-card>
  </div>
</template>

<style lang="scss" scoped>



.modal-xl {
  max-width: 100% !important;
  padding-right: 17px;
}

:deep .dark-modal {
  color: white;
  background-color: #293039;
  border-bottom: 1px solid #444c56;
}

:deep .dark-modal-body {
  color: white;
  background-color: #293039;
}

</style>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import TemplatesTable from '@/view/pages/ml/templates/TemplatesTable.vue';
import TemplateEditorModal from './templates/TemplateEditorModal.vue';
import SendoutTemplateComponent from '@/view/pages/ml/sendout_template/SendoutTemplateComponent.vue';
import PDFTemplateTable from '@/view/pages/ml/pdf_template/PDFTemplateTable.vue';
import PDFTemplateEditorModal from '@/view/pages/ml/pdf_template/PDFTemplateEditorModal.vue';
import ErrorPopup from '@/view/components/ErrorPopup.vue';

export default {
  name: 'TemplatesEmail',
  mixins: [ toasts ],
  components: {
    TemplatesTable,
    TemplateEditorModal,
    SendoutTemplateComponent,
    ErrorPopup,
    PDFTemplateTable,
    PDFTemplateEditorModal
  },
  computed: {
    tabs() {

      let base = [
        { label: 'TEMPLATE.TEMPLATES', disabled: false },
        { label: 'TEMPLATE.PDF_TEMPLATES', disabled: false },
        { label: 'COMMON.SETTINGS', disabled: false },

      ];
      
      return base;
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'isTHS']),
    
    fullscreen_visible() {
      const display = this.fullscreen ? 'block' : 'none';
      return `display:${display}`;
    },

  },
  mounted() {
    // temporary fix on third party
    //this.error_popup_message = 'ERR_TEMPLATES_UNAVAILABLE';
    //this.$nextTick(()=>{ this.error_popup_message = null; });
    this.load_templates();
  },
  data() {
    return {
      selected_template_id: null,
      show_system: false,
      show_theme: false,
      active_tab: 0,
      selected_pdf_template: null,
      error_popup_message: null,

      templates: [],

      sendout_id: null
    };
  },
  watch: {

    currentCompanyId(newValue, oldvalue) {
      if (newValue) {
        this.load_templates();
      }
    }
  },
  methods: {

    refresh_templates(show_system, show_theme) {
      this.show_system = show_system;
      this.show_theme = show_theme;

      this.load_templates();
    },

    pdf_template_created(item) {
      this.$refs['pdf-template-table'].refresh();
    },

    pdf_template_updated(item) {
      this.$refs['pdf-template-table'].refresh();
    },


    pdf_template_selected(item) {

      this.selected_pdf_template = item;
      //this.selected_pdf_template_id = id;

      this.$nextTick(()=>{
        this.$refs['pdf-template-editor-modal'].show();
      });

    },

    async pdf_template_deleted(id) {
      const res = await axios.delete(`/pdf_template/${id}`);

      if (res.status === 204) {
        this.$refs['pdf-template-table'].refresh();
      }
    },

    pdf_template_create() {
      this.selected_pdf_template = {};

      this.$nextTick(()=>{
        this.$refs['pdf-template-editor-modal'].show();
      });
    },

    createdTemplate(template) {
      this.templates.push(template);
    },
    updateTemplate(template) {
      const index = this.templates.findIndex(i => i.template_id === template.template_id)

      if (index >= 0) {
        this.templates[index] = { ...template };
      }
    },

    create_template_clicked() {
      this.$refs['template-editor-modal'].create();
    },
    
    async copy_template(template) {
      const loader = this.$loading.show();

      try {

        const res = await axios.post(`/template/copy`, { template_id: template.template_id })
        
        if (res.status === 201) {
          this.templates.push(res.data);
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.COPIED'));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
        }
      }
      catch (err) {
        console.error('copy template error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_COPY'));
      }

      loader && loader.hide();
    },
    deleteTemplateClicked(template_id) {
      this.toDelete = template_id;
      this.$refs['deleteTemplateConfirm'].show();
    },
    onDeleteTemplateConfirm() {
      this.delete_template(this.toDelete);
      this.toDelete = null;
    },

    async delete_template(template_id) {
      try {
        const loader = this.$loading.show();

        const res = await axios.delete(`/template/${template_id}`);

        loader && loader.hide();

        if (res.status === 204)  {
          this.templates = this.templates.filter(item => item.template_id !== template_id);

          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.DELETED'));

          return;
        }
      }
      catch (err) {
        loader && loader.hide();

        console.error('delete_template error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_DELETE'));

    },
    changeSystem(template) {
      const loader = this.$loading.show();

      axios
        .put(`/template/${template.template_id}`, template)
        .then(res => {
          loader && loader.hide();
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TEMPLATE.UPDATED'));
        })
        .catch(err => {
          loader && loader.hide();
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_UPDATE'));
        });
    },

    selectTemplate(template_id) {
      this.selected_template_id = null;

      this.$nextTick(()=>{
        this.selected_template_id = template_id;
        this.$refs['template-editor-modal'].show();
      });
      
    },
    async load_templates() {

      const loader = this.$loading.show();

      try {
        this.templates = [];
        const res = await axios.get(`/template?company_id=${this.currentCompanyId}&show_system=${this.show_system}&show_theme=${this.show_theme}`);
    
        if (res.status === 200) {
          this.templates = res.data.filter(i => i.is_email);
        }
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_LIST'));
      }

      loader.hide();
    },
    
    backToSendout() {
      this.$router.push(`/ml-sendout/${this.sendout_id}`);
    },

    resetForm() {
      this.template = {
        template_id: '',
        reply_to: '',
        name: '',
        subject: '',
        type: [],
        content: '',
        template: '',
        edit_html: null,
        text: '',
        stickprov: false,
        from_email: null
      };
    },

  }
};
</script>
